import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProfileDataResponseDto } from "../../dtos/get-profile-data-response-dto";
import { ProfileService } from "../../services/profile-service";

type UseGetProfileDataQueryParams = {
  options?: Omit<
    UseQueryOptions<GetProfileDataResponseDto>,
    "queryKey" | "queryFn"
  >;
};

export const useGetProfileDataQuery = ({
  options
}: UseGetProfileDataQueryParams = {}) => {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      return await ProfileService.getProfileData();
    },
    ...options
  });
};
